/** Tenant → Settings. The static page was a mock — hardcoded fax and billing
 *  forms wired to nothing. This is the honest version: what is real renders,
 *  what is not stays absent rather than pretending to save. */
import { useSession } from '../session';

export function Settings() {
  const { me } = useSession();

  return (
    <>
      <div className="page__head">
        <div>
          <h1>Settings</h1>
          <p className="sub">Your account and organization</p>
        </div>
      </div>

      <div className="grid grid-2">
        <div className="panel">
          <div className="panel__head">
            <h2>Your account</h2>
          </div>
          <div className="panel__body">
            <table className="tbl">
              <tbody>
                <tr>
                  <td className="dim" style={{ width: 150 }}>
                    Name
                  </td>
                  <td className="strong">{me.user.name}</td>
                </tr>
                <tr>
                  <td className="dim">Email</td>
                  <td>{me.user.email}</td>
                </tr>
                <tr>
                  <td className="dim">Role</td>
                  <td>{me.user.roleLabel}</td>
                </tr>
                <tr>
                  <td className="dim">Organization</td>
                  <td>{me.company.name}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="panel__foot">
            Your password is held by Identity Platform — change it with “Forgot password?” on the sign-in page. Tenpoint never
            stores one.
          </div>
        </div>

        <div className="panel">
          <div className="panel__head">
            <h2>Organization</h2>
          </div>
          <div className="panel__body">
            <table className="tbl">
              <tbody>
                <tr>
                  <td className="dim" style={{ width: 150 }}>
                    Name
                  </td>
                  <td className="strong">{me.company.name}</td>
                </tr>
                <tr>
                  <td className="dim">Team</td>
                  <td>
                    {me.company.userCount} user{me.company.userCount === 1 ? '' : 's'}
                  </td>
                </tr>
                <tr>
                  <td className="dim">Status</td>
                  <td>
                    <span className={`tag tag--${me.company.status === 'active' ? 'ok' : 'warn'}`}>{me.company.status}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="panel__foot">
            Organization details — addresses, billing, contact info — are managed with Tenpoint during onboarding.
          </div>
        </div>
      </div>
    </>
  );
}
